import {Injectable} from "@angular/core";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {Observable} from "rxjs";

/**
 * Use case for retrieving the current selected delivery point.
 */
@Injectable({
    providedIn: 'root'
})
export class GetCurrentDeliveryPointUseCase {
    constructor(private deliveryPointLocal: DeliveryPointLocal) { }

    /**
     * Retrieves the current selected delivery point.
     *
     * @returns An observable that emits the current delivery point or null if none exists.
     *          Each time the delivery point changes, the observable will emit a new value.
     */
    execute(): Observable<DeliveryPoint | null> {
        return this.deliveryPointLocal.currentDeliveryPoint$
    }
}
